<section id="history" class="page-banner parallax-section">
    <div class="container-fluid text-center">
        <div class="row">
            <!-- <div class=" wow fadeInLeft col-md-1">
                <div class="d-flex" style="height: 100px;">
                    <div class="vr"></div>
                  </div>
            </div> -->
            <div class="wow fadeInUp offset-md-3 col-md-6 col-sm-7 " data-wow-delay="0.6s">
                <h1>Our Process</h1>
                <ul>
                  <li>
                    <a routerlink="/" href="/">Home</a>
                  </li>
                  <li>Recruitment Process</li>
                </ul>
            </div>
        </div> 
    </div>
</section>
<!-- PROCESS SECTION -->
<section id="process" class="our-process p-0 m-0 bg-silver">
    <div class="container work-process  pb-5 pt-5">
        <div class="title mb-5 text-center">
        <h2 class="content-title">Recruitment Process</h2>
    </div>
    <div class="container pb-5 text-justify">
      <p style="font-size: 18px;"><strong>7107 Islands Placement and Promotions, Inc.</strong> guarantees that all Filipino manpower deployed have passed through, and have been properly screened, processed and approved by Philippine Overseas Employment Administration (POEA)
        and Embassy of Country of Assignments. The company ensures that every Filipi
        no worker deployed overseas have complied with all relevant Philippine legal processing requirements.
        7107 Islands Placement and promotions Inc. follows these guidelines and procedures to ensure quality of workers being sent abroad</p>
    </div>
        <!-- ============ step 1 =========== -->
        <div class="row">
            <div class="col-md-5">
                <div class="process-box process-left wow fadeInLeft" data-wow-delay="0.1s" style="z-index: 101" data-bs-toggle="modal" data-bs-target="#stepModal1">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="process-step">
                                <p class="m-0 p-0">Step</p>
                                <h2 class="m-0 p-0">01</h2>
                            </div>
                        </div>
                        <div class="col-md-7">
                            <h6 class="process-title">
                              THOROUGH SELECTION OF CANDIDATES
                            </h6>
                        </div>
                    </div>
                    <div class="process-line-l"></div>
                </div>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-5">
                <div class="process-point-right"></div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="stepModal1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">THOROUGH SELECTION OF CANDIDATES</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p>Our selection process starts from sourcing candidates who are currently
                  employed in their field of specialization by the difference industries and
                  companies.</p>
              </div>
            </div>
          </div>
        </div>
        <!-- ============ step 2 =========== -->
        <div class="row">
            
            <div class="col-md-5">
                <div class="process-point-left"></div>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-5">
                <div class="process-box process-right wow fadeInRight" data-wow-delay="0.2s" style="z-index: 102" data-bs-toggle="modal" data-bs-target="#stepModal2">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="process-step">
                                <p class="m-0 p-0">Step</p>
                                <h2 class="m-0 p-0">02</h2>
                            </div>
                        </div>
                        <div class="col-md-7">
                            <h6>BACKGROUND VERIFICATION OF CANDIDATE'S EMPLOYMENT AND
                              PERSONAL HISTORY</h6>
                        </div>
                    </div>
                    <div class="process-line-r"></div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="stepModal2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">BACKGROUND VERIFICATION OF CANDIDATE'S EMPLOYMENT AND
                  PERSONAL HISTORY</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p>
                  Candidate's employment and personal histories are carefully verified, current &
                  previous company, police clearance is required from candidates through the
                  Government National Bureau of Investigation to ensure that every candidate
                  selected has no derogatory record.</p>
              </div>
            </div>
          </div>
        </div>
        <!-- ============ step 3 =========== -->
        <div class="row">
            <div class="col-md-5">
                <div class="process-box process-left wow fadeInLeft" data-wow-delay="0.3s" style="z-index: 103" data-bs-toggle="modal" data-bs-target="#stepModal3">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="process-step">
                                <p class="m-0 p-0">Step</p>
                                <h2 class="m-0 p-0">03</h2>
                            </div>
                        </div>
                        <div class="col-md-7">
                            <h6>TRADE TEST OF CANDIDATES</h6>
                        </div>
                    </div>
                    <div class="process-line-l"></div>
                </div>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-5">
                <div class="process-point-right"></div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="stepModal3" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">TRADE TEST OF CANDIDATES</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p>
                  Our agency has contract with a well known trade testing center accredited by
                  the Department of Labor and Employment. The best qualified for each position
                  selected during the final interview is trade tested for practical job knowledge
                  and skill application. The candidate who obtains the highest trade test result
                  or rating is selected for the employer's requirements and final approval.</p>
              </div>
            </div>
          </div>
        </div>
        <!-- ============ step 4 =========== -->
        <div class="row">
            <div class="col-md-5">
                <div class="process-point-left"></div>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-5">
                <div class="process-box process-right wow fadeInRight" data-wow-delay="0.4s" style="z-index: 104" data-bs-toggle="modal" data-bs-target="#stepModal4">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="process-step">
                                <p class="m-0 p-0">Step</p>
                                <h2 class="m-0 p-0">04</h2>
                            </div>
                        </div>
                        <div class="col-md-7">
                            <h6>MEDICAL AND PSYCHOLOGICAL TEST OF CANDIDATES</h6>
                        </div>
                    </div>
                    <div class="process-line-r"></div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="stepModal4" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">MEDICAL AND PSYCHOLOGICAL TEST OF CANDIDATES</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p>
                  Candidates selected are required to undergo rigid physical and psychological
                  examinations with a modern clinic accredited by the Department of Health to
                  ensure that they are both physically and mentally fit to perform their jobs.</p>
              </div>
            </div>
          </div>
        </div>
        <!-- ============ step 5 =========== -->
        <div class="row">
            <div class="col-md-5">
                <div class="process-box process-left wow fadeInLeft" data-wow-delay="0.5s" style="z-index: 105" data-bs-toggle="modal" data-bs-target="#stepModal5">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="process-step">
                                <p class="m-0 p-0">Step</p>
                                <h2 class="m-0 p-0">05</h2>
                            </div>
                        </div>
                        <div class="col-md-7">
                            <h6>FULL DOCUMENTATION ASSISTANCE FOR SELECTED CANDIDATES</h6>
                        </div>
                    </div>
                    <div class="process-line-l"></div>
                </div>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-5">
                <div class="process-point-right"></div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="stepModal5" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">FULL DOCUMENTATION ASSISTANCE FOR SELECTED CANDIDATES</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p>
                  We provide full documentation assistance for selected candidates including
                  acquisition of passports, authentication of education certification
                  (for professionals), clearances, and exit passage required by the government,
                  travel tax exemption certificate and withdrawal of visas from the respective
                  embassy.</p>
              </div>
            </div>
          </div>
        </div>
        <!-- ============ step 6 =========== -->
        <div class="row">
          <div class="col-md-5">
              <div class="process-point-left"></div>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-5">
              <div class="process-box process-right wow fadeInRight" data-wow-delay="0.6s" style="z-index: 104" data-bs-toggle="modal" data-bs-target="#stepModal6">
                  <div class="row">
                      <div class="col-md-5">
                          <div class="process-step">
                              <p class="m-0 p-0">Step</p>
                              <h2 class="m-0 p-0">06</h2>
                          </div>
                      </div>
                      <div class="col-md-7">
                          <h6>PRE-DEPARTURE ORIENTATION SEMINAR OF WORKERS</h6>
                      </div>
                  </div>
                  <div class="process-line-r"></div>
              </div>
          </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="stepModal6" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">PRE-DEPARTURE ORIENTATION SEMINAR OF WORKERS</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p>
                The selected candidates will undergo a most comprehensive predeparture
                orientation seminar conducted by our coordination for Human Resources.
                Topics include working and living conditions customs, traditions, religion,
                significant laws and regulations of the host country.</p>
            </div>
          </div>
        </div>
      </div>
      <!-- ============ step 7 =========== -->
      <div class="row">
        <div class="col-md-5">
            <div class="process-box process-left wow fadeInLeft" data-wow-delay="0.7s" style="z-index: 103" data-bs-toggle="modal" data-bs-target="#stepModal7">
                <div class="row">
                    <div class="col-md-5">
                        <div class="process-step">
                            <p class="m-0 p-0">Step</p>
                            <h2 class="m-0 p-0">07</h2>
                        </div>
                    </div>
                    <div class="col-md-7">
                        <h6>AIRPORT ASSISTANCE</h6>
                    </div>
                </div>
                <div class="process-line-l"></div>
            </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="process-point-right"></div>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="stepModal7" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">AIRPORT ASSISTANCE</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>
              On the day of the worker's departure from the point of hire, our representative
              will render assistance to them at the airport for smooth and orderly departure.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- ============ step 8 =========== -->
    <div class="row">
      <div class="col-md-5">
          <div class="process-point-left"></div>
      </div>
      <div class="col-md-2"></div>
      <div class="col-md-5">
          <div class="process-box process-right wow fadeInRight" data-wow-delay="0.8s" style="z-index: 104" data-bs-toggle="modal" data-bs-target="#stepModal8">
              <div class="row">
                  <div class="col-md-5">
                      <div class="process-step">
                          <p class="m-0 p-0">Step</p>
                          <h2 class="m-0 p-0">08</h2>
                      </div>
                  </div>
                  <div class="col-md-7">
                      <h6>GUARANTEE OF WORKERS WE RECRUIT</h6>
                  </div>
              </div>
              <div class="process-line-r"></div>
          </div>
      </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="stepModal8" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">GUARANTEE OF WORKERS WE RECRUIT</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p>
                7107 Placement & Promotions, Inc. guarantees that the workers we hire and deploy are mentally and physically fit work and capable to perform their jobs.</p>
            </div>
          </div>
        </div>
      </div>
      <!-- ============ step 9 =========== -->
        <div class="row">
          <div class="col-md-5">
              <div class="process-box process-left wow fadeInLeft" data-wow-delay="0.9s" style="z-index: 103" data-bs-toggle="modal" data-bs-target="#stepModal9">
                  <div class="row">
                      <div class="col-md-5">
                          <div class="process-step">
                              <p class="m-0 p-0">Step</p>
                              <h2 class="m-0 p-0">09</h2>
                          </div>
                      </div>
                      <div class="col-md-7">
                          <h6>DELIVER TIME OF WORKERS</h6>
                      </div>
                  </div>
                  <div class="process-line-l"></div>
              </div>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-5">
              <div class="process-point-right"></div>
          </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="stepModal9" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">DELIVER TIME OF WORKERS</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p>
                7107 Placement & Promotions Inc,, can complete the process of the workers
                papers within a maximum of Fifteen (15) working days and deployment period
                within thirty (30) working days from the date of receipt of your manpower
                requirements.</p>
            </div>
          </div>
        </div>
      </div>
      <!-- ============ step 10 =========== -->
      <div class="row">
        <div class="col-md-5">
            <div class="process-point-left"></div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="process-box process-right wow fadeInRight" data-wow-delay="1s" style="z-index: 104" data-bs-toggle="modal" data-bs-target="#stepModal10">
                <div class="row">
                    <div class="col-md-5">
                        <div class="process-step">
                            <p class="m-0 p-0">Step</p>
                            <h2 class="m-0 p-0">10</h2>
                        </div>
                    </div>
                    <div class="col-md-7">
                        <h6>PERIODIC PROGRESS REPORT</h6>
                    </div>
                </div>
                <div class="process-line-r"></div>
            </div>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="stepModal10" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">PERIODIC PROGRESS REPORT</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>
              We provide a weekly periodic report to ensure that you get up-to date statusregarding the processing up to the time workers are scheduled for deployment.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- ============ step 11 =========== -->
    <div class="row">
      <div class="col-md-5">
          <div class="process-box process-left wow fadeInLeft" data-wow-delay="1.1s" style="z-index: 103" data-bs-toggle="modal" data-bs-target="#stepModal11">
              <div class="row">
                  <div class="col-md-5">
                      <div class="process-step">
                          <p class="m-0 p-0">Step</p>
                          <h2 class="m-0 p-0">11</h2>
                      </div>
                  </div>
                  <div class="col-md-7">
                      <h6>TRAVEL ARRANGEMENT</h6>
                  </div>
              </div>
              <div class="process-line-l"></div>
          </div>
      </div>
      <div class="col-md-2"></div>
      <div class="col-md-5">
          <div class="process-point-right"></div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="stepModal11" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">TRAVEL ARRANGEMENT</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>
            7107 Placement & Promotions Inc., is accredited with all the Airlines as well as
            with a local travel agencies to facilitate any ticketing requirements or flight
            booking of the selected workers if and when is require by our clients.</p>
        </div>
      </div>
    </div>
    </div>
    <!-- ============ step 12 =========== -->
    <div class="row">
    <div class="col-md-5">
        <div class="process-point-left process-last"></div>
    </div>
    <div class="col-md-2"></div>
    <div class="col-md-5">
        <div class="process-box process-right wow fadeInRight" data-wow-delay="1.2s" style="z-index: 104" data-bs-toggle="modal" data-bs-target="#stepModal12">
            <div class="row">
                <div class="col-md-5">
                    <div class="process-step">
                        <p class="m-0 p-0">Step</p>
                        <h2 class="m-0 p-0">12</h2>
                    </div>
                </div>
                <div class="col-md-7">
                    <h6>AFTER DISPATCH SERVICE</h6>
                </div>
            </div>
            <div class="process-line-r"></div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="stepModal12" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">AFTER DISPATCH SERVICE</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>
            It is our company policy to contact our clients after the deployment of our
            workers to check and monitor work- ers' status, particularly their working
            attitude, work performance, health, accommodation and other matters
            pertaining to their employment. Our company promotes constant coordination
            with clients.</p>
        </div>
        </div>
      </div>
    </div>


  </div>
</section>